/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  background: "#ddeff3",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const defaultOption = [
  {
    value: "title",
    label: "title",
    disabled: true,
  },
];

const wineSymbolOption = [
  {
    value: "TR02T",
    label: "TR02T",
    disabled: false,
  },
  {
    value: "TR02C",
    label: "TR02C",
    disabled: false,
  },
  {
    value: "TR01C",
    label: "TR01C",
    disabled: false,
  },
  {
    value: "TR01T",
    label: "TR01T",
    disabled: false,
  },
  {
    value: "TR01R",
    label: "TR01R",
    disabled: false,
  },
];

const noteOption = [
  {
    value: "Chưa sử dụng",
    label: "Chưa sử dụng",
    disabled: false,
  },
  {
    value: "Đã viết chưa báo cáo sử dụng",
    label: "Đã viết chưa báo cáo sử dụng",
    disabled: false,
  },
  {
    value: "Đã viết và đã báo cáo sử dụng",
    label: "Đã viết và đã báo cáo sử dụng",
    disabled: false,
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    wineSymbol: {
      type: "select",
      value: null,
      bg: false,
      option: wineSymbolOption,
    },
    wineName: {
      type: "input",
      value: null,
      bg: false,
    },
    denominator: {
      type: "input",
      value: null,
      bg: false,
    },

    quantity: {
      type: "input",
      value: 0,
      bg: true,
    },
    from: {
      type: "input",
      value: null,
      bg: false,
    },
    to: {
      type: "input",
      value: null,
      bg: false,
    },
    startDate: {
      type: "input",
      value: null,
      bg: false,
    },
    receipt: {
      type: "input",
      value: null,
      bg: false,
    },
    note: {
      type: "select",
      value: null,
      bg: false,
      option: noteOption,
    },
  },
];
export default function WineStampsTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      wineSymbol: {
        type: "select",
        value: null,
        bg: false,
        option: wineSymbolOption,
      },
      wineName: {
        type: "input",
        value: null,
        bg: false,
      },
      denominator: {
        type: "input",
        value: null,
        bg: false,
      },

      quantity: {
        type: "input",
        value: 0,
        bg: true,
      },
      from: {
        type: "input",
        value: null,
        bg: false,
      },
      to: {
        type: "input",
        value: null,
        bg: false,
      },
      startDate: {
        type: "input",
        value: null,
        bg: false,
      },
      receipt: {
        type: "input",
        value: null,
        bg: false,
      },
      note: {
        type: "select",
        value: null,
        bg: false,
        option: noteOption,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Ký hiệu mẫu</Th>
              <Th style={{ textAlign: "center" }}>Tên tem rượu</Th>
              <Th style={{ textAlign: "center" }}>Ký hiệu</Th>
              <Th style={{ textAlign: "center" }}>Từ số</Th>
              <Th style={{ textAlign: "center" }}>Đến số</Th>
              <Th style={{ textAlign: "center" }}>Số lượng</Th>
              <Th style={{ textAlign: "center" }}>Ghi chú</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                (5)
              </Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {index + 1}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.wineSymbol.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.wineSymbol.bg ? (
                      row.receiptId.value
                    ) : row.wineSymbol?.type === "select" ? (
                      <SelectTable
                        name="wineSymbol"
                        id={row.id.value}
                        option={row.wineSymbol.option ? row.wineSymbol.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="wineSymbol"
                        value={row.wineSymbol.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.wineName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.wineName?.type !== "input" ? (
                      row.wineName.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="wineName"
                        value={row.wineName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.denominator.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.denominator?.type !== "input" ? (
                      row.denominator.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="denominator"
                        value={row.denominator.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.from.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.from?.type !== "input" ? (
                      row.from.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="from"
                        value={row.from.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.to.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.to?.type !== "input" ? (
                      row.to.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="to"
                        value={row.to.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="quantity"
                        min={0}
                        value={row.quantity.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.note.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.note.bg ? (
                      row.note.value
                    ) : row.note?.type === "select" ? (
                      <SelectTable
                        name="note"
                        id={row.id.value}
                        option={row.note.option ? row.note.option : defaultOption}
                        onSelect={handleChange}
                        style={{
                          width: "200px",
                        }}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="note"
                        value={row.note.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      type={fields}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
